/**

 * Identifica o tipo de documento fiscal vinculado à venda.

 */



import { isChaveNfce, isChaveNfe55 } from './fiscalChaveUtils'



export const VENDA_DOC_TIPO = {

  NFE: 'nfe',

  NFCE: 'nfce',

  CUPOM: 'cupom',

  NENHUM: 'nenhum'

}



function hasNfeLink(venda) {

  const id = venda?.nfe_id ?? venda?.linked_nfe_id

  return id != null && id !== '' && String(id) !== 'null'

}


function resolveTipoFromSaleFields(venda) {
  if (hasNfeLink(venda)) return VENDA_DOC_TIPO.NFE

  const explicit = (venda?.fiscal_document_type || '').toLowerCase()
  if (explicit === 'nfe' || explicit === 'nfce' || explicit === 'cupom') {
    return explicit
  }



  const chave = venda?.chave_nfe

  if (chave && String(chave).trim()) {

    if (isChaveNfe55(chave)) return VENDA_DOC_TIPO.NFE

    if (isChaveNfce(chave)) return VENDA_DOC_TIPO.NFCE

  }



  return VENDA_DOC_TIPO.CUPOM

}



export function getVendaDocumentoFiscal(venda) {

  if (!venda) return { tipo: VENDA_DOC_TIPO.NENHUM }



  const tipo = resolveTipoFromSaleFields(venda)



  if (tipo === VENDA_DOC_TIPO.NFE) {

    const nfeId = venda.nfe_id ?? venda.linked_nfe_id

    return {

      tipo: VENDA_DOC_TIPO.NFE,

      nfeId,

      status: venda.nfe_status,

      number: venda.nfe_number,

      accessKey: venda.nfe_access_key,

      urlPdf: venda.nfe_url_pdf

    }

  }



  if (tipo === VENDA_DOC_TIPO.NFCE) {

    return {

      tipo: VENDA_DOC_TIPO.NFCE,

      chave: venda.chave_nfe,

      status: venda.status_nfe,

      urlPdf: venda.url_pdf

    }

  }



  return { tipo: VENDA_DOC_TIPO.CUPOM }

}



export function getDocumentoFiscalLabel(tipo) {

  switch (tipo) {

    case VENDA_DOC_TIPO.NFE:

      return 'NF-e'

    case VENDA_DOC_TIPO.NFCE:

      return 'NFC-e'

    case VENDA_DOC_TIPO.CUPOM:

      return 'Cupom'

    default:

      return '—'

  }

}

const FINALIZED_STATUSES = ['completed', 'confirmed']

/** Venda Cupom elegível para emissão tardia de NFC-e / NF-e (sem alterar estoque). */
export function canEmitirNotaFiscal(venda) {
  if (!venda) return false
  if (venda.status === 'cancelled') return false
  if (!FINALIZED_STATUSES.includes(venda.status)) return false
  if (venda.chave_nfe || venda.nfe_id) return false

  const doc = getVendaDocumentoFiscal(venda)
  return doc.tipo === VENDA_DOC_TIPO.CUPOM || doc.tipo === VENDA_DOC_TIPO.NENHUM
}

const AUTHORIZED_STATUSES = new Set([
  'autorizado', 'authorized',
  'transmitida', 'transmitted', 'transmitido',
  'saved', 'salva'
])

const BLOCKED_STATUSES = new Set([
  'erro', 'error', 'rejeitado', 'rejeitada',
  'cancelada', 'cancelled', 'pendente', 'pending', 'draft', 'rascunho'
])

function isFiscalStatusAuthorized(status, { hasValidKey = false } = {}) {
  const st = String(status || '').toLowerCase().trim()
  if (!st) return hasValidKey
  if (BLOCKED_STATUSES.has(st)) return false
  if (AUTHORIZED_STATUSES.has(st)) return true
  if (st === 'processando' || st === 'processando_autorizacao') return false
  return hasValidKey
}

function hasValidAccessKey(chave) {
  const digits = String(chave || '').replace(/\D/g, '')
  return digits.length >= 44
}

function isNotaOriginalAutorizada(venda) {
  const doc = getVendaDocumentoFiscal(venda)

  if (doc.tipo === VENDA_DOC_TIPO.NFCE) {
    const st = venda.status_nfe || doc.status || ''
    const hasKey = hasValidAccessKey(venda.chave_nfe || doc.chave)
    return isFiscalStatusAuthorized(st, { hasValidKey: hasKey })
  }

  if (doc.tipo === VENDA_DOC_TIPO.NFE) {
    const st = venda.nfe_status || doc.status || ''
    const hasKey = hasValidAccessKey(venda.nfe_access_key || doc.accessKey)
    return isFiscalStatusAuthorized(st, { hasValidKey: hasKey })
  }

  return false
}

/** Venda com NFC-e/NF-e autorizada elegível para NF de devolução. */
export function canEmitirDevolucao(venda) {
  if (!venda) return false
  if (venda.status === 'cancelled') return false
  if (!FINALIZED_STATUSES.includes(venda.status)) return false

  const doc = getVendaDocumentoFiscal(venda)
  if (doc.tipo !== VENDA_DOC_TIPO.NFCE && doc.tipo !== VENDA_DOC_TIPO.NFE) return false
  if (!isNotaOriginalAutorizada(venda)) return false
  if (venda.has_fiscal_return) return false
  if (canRetryDevolucaoFiscal(venda)) return false

  return true
}

export function canRetryDevolucaoFiscal(venda) {
  if (!venda) return false
  const st = String(venda.sale_return_fiscal_status || venda.sale_return_status || '').toLowerCase()
  return st === 'failed' || st === 'fiscal_failed'
}

export function getDevolucaoBadge(venda) {
  if (venda?.has_fiscal_return) {
    return { label: 'Devolvida', bg: '#fee2e2', color: '#991b1b' }
  }
  if (canRetryDevolucaoFiscal(venda)) {
    return { label: 'NF pendente', bg: '#ffedd5', color: '#c2410c' }
  }
  if (venda?.has_partial_return) {
    return { label: 'Parcial', bg: '#fef3c7', color: '#b45309' }
  }
  return null
}

